import { useRouter } from 'next/router';
import { splitByLastDoubleUnderscore } from 'modules/WorkflowV2/utils/splitByLastDoubleUnderscore';
import { useGetModel } from 'modules/Playground/api/hooks/useGetModel';

interface ModelQueryParams {
  model?: string;
  user_id?: string;
  app_id?: string;
  model2?: string;
  model2_user_id?: string;
  model2_app_id?: string;
}

const useModelParamsByPanelId = (panelId: 'left' | 'right') => {
  const router = useRouter();
  const query = router.query as ModelQueryParams;

  const modelQuery = panelId === 'left' ? (query.model as string | undefined) : (query.model2 as string | undefined);
  const userId = panelId === 'left' ? (query.user_id as string | undefined) : (query.model2_user_id as string | undefined);
  const appId = panelId === 'left' ? (query.app_id as string | undefined) : (query.model2_app_id as string | undefined);

  return { modelQuery, userId, appId };
};

export const useGetModelByQueryParam = (
  panelId: 'left' | 'right',
): {
  model: CF.API.Models.Model;
  isFetching: boolean;
} => {
  const { modelQuery, userId, appId } = useModelParamsByPanelId(panelId);

  const [modelId, modelVersionId] = splitByLastDoubleUnderscore(modelQuery);

  const { data: model, isFetching } = useGetModel(
    {
      params: {
        userAppIdUserId: userId,
        userAppIdAppId: appId,
        modelId,
      },
      query: {
        version_id: modelVersionId,
      },
    },
    undefined,
  );

  return {
    model: model?.model as unknown as CF.API.Models.Model,
    isFetching,
  };
};
